function createModal(content) {
  // Create modal element
  const modal = document.createElement('aside');
  modal.classList.add('modal');
  modal.setAttribute('id', 'modal');

  // Create close button element
  const closeBtn = document.createElement('div');
  closeBtn.classList.add('modal__close');
  closeBtn.setAttribute('id', 'modal-close');
  modal.appendChild(closeBtn);

  // Create modal content wrapper element
  const wrapper = document.createElement('div');
  wrapper.classList.add('modal__wrapper');
  wrapper.innerHTML = content; // Add content to the modal wrapper
  modal.appendChild(wrapper);

  // Add event listener to close modal when clicked outside of modal content
  modal.addEventListener('click', (event) => {
    if (event.target === modal || event.target === closeBtn) {
      wrapper.innerHTML = ''; // clear modal content

      modal.setAttribute('data-visible', 'false'); // Set visibility to false before removing modal
      setTimeout(() => {
        modal.remove(); // remove modal from the DOM
      }, 500);
    }
  });

  // Add modal to the DOM
  document.body.appendChild(modal);

  // Set data-visible to true after the modal is injected into the DOM
  setTimeout(() => {
    modal.setAttribute('data-visible', 'true');
  }, 0);

  // Return the newly created modal element
  return modal;
}
